import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DialogService } from 'src/app/_services/dialog.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { Router } from '@angular/router';

export interface NavItem {
  displayName: string;
  disabled?: boolean;
  iconName: string;
  route?: string;
  children?: NavItem[];
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  
  baseUrl = environment.baseUrl;
  isLogin = false;
  // user_dept: string = null;
  user_dept: any;
  logged_in_user: any = null;
  navItems: NavItem[] = [];
  hotelNavItems: NavItem[] = [];
  restaurantNavItems: NavItem[] = [];
  schoolNavItems: NavItem[] = [];
  instructorNavItems: NavItem[] = [];

  
  constructor(private http:HttpClient,
    private dialogService: DialogService, 
    private loading : LoadingService,
    private router:Router,
    ) {
      this.bindSchoolNavbar();
      this.bindInstructorNavbar(); 
    }

  connect_to_server(){
    return this.http.get(this.baseUrl + '/connection');    
  }

  login(email, password) 
  {
    let branch_id = 201;
    return this.http.post(this.baseUrl + '/login',
      { 
        email, 
        password,
        branch_id
      });
  }

  isLoggedIn() {
    return !!localStorage.getItem('dschool_id_token');
  }

  validate_token() {
    return this.http.post(this.baseUrl + '/validate_token',{});
  }

  onlogoutClick() {
    this.dialogService.openConfirmDialog('Are you sure want to logout?')
      .afterClosed().subscribe(res =>{
        if(res) {
          this.loading.spin$.next(true);
          this.logout().subscribe(data=>{
            //console.log(data);
            if(JSON.stringify(data['status'])=='true') {
              localStorage.removeItem('dschool_id_token');
              this.isLogin = false;
              this.user_dept = null;
              this.loading.spin$.next(false);
              this.router.navigate(['/login']);
            }
          });
        }
    });
  }

  logout() {
    return this.http.post(this.baseUrl + '/logout',{});
  }

  getToken() {
    return localStorage.getItem('dschool_id_token');
  }

  bindNavbar(logged_in_user_data) {    
    this.logged_in_user = logged_in_user_data;
    this.user_dept = this.logged_in_user.role;
    let user_dept = this.user_dept;
    //console.log(user_dept);
    this.bindHotelNavbar();
    this.bindRestaurantNavbar();
    
  }

  bindHotelNavbar() {
    let user_dept = this.user_dept;
    this.hotelNavItems = [];
    if(user_dept=="master"){
      this.hotelNavItems = [
        {
          displayName: 'Dashboard',
          iconName: 'star_rate',
          route: '/',
        },
        {
          displayName: 'Administrator',
          iconName: 'star_rate',
          route: 'admin',
          children: [
            {
              displayName: 'Companies',
              iconName: 'star_rate',
              route: 'administrator/companies'
            }              
          ]
        }
      ];
    }
   
    else if(user_dept=="test"){
      this.hotelNavItems = [
        {
          displayName: 'Dashboard',
          iconName: 'star_rate',
          route: '/',
        },
        {
          displayName: 'MainMenu',
          iconName: 'star_rate',
          route: 'main',
          children: [
            {
              displayName: 'Dashboard',
              iconName: 'star_rate',
              route: 'main/dashboard'
            },
            {
              displayName: 'Users',
              iconName: 'person',
              route: 'main/users'
            },
            {
              displayName: 'Menu',
              iconName: 'star_rate',
              route: 'main/menu',
               children: [
                  {
                    displayName: 'Sub Menu',
                    iconName: 'star_rate',
                    route: 'main/menu/submenu'
                  },
                ]
            },
          ]
        },
        {
          displayName: 'MyMenu',
          iconName: 'star_rate',
          route: 'mymenu',
          children: [
            {
              displayName: 'Home',
              iconName: 'star_rate',
              route: 'mymenu/dashboard',
            },
            {
              displayName: 'Users',
              iconName: 'person',
              route: 'mymenu/users'
            },        
          ]
        },
        {
          displayName: 'MyMenu',
          iconName: 'star_rate',
          route: 'mymenu',
          children: [
            {
              displayName: 'Home',
              iconName: 'star_rate',
              route: 'mymenu/dashboard',
            },
            {
              displayName: 'Users',
              iconName: 'person',
              route: 'mymenu/users'
            },        
          ]
        },
        {
          displayName: 'MyMenu',
          iconName: 'star_rate',
          route: 'mymenu',
          children: [
            {
              displayName: 'Home',
              iconName: 'star_rate',
              route: 'mymenu/dashboard',
            },
            {
              displayName: 'Users',
              iconName: 'person',
              route: 'mymenu/users'
            },        
          ]
        },
      ];
    }
  }

  bindRestaurantNavbar(){
    let user_dept = this.user_dept;
    this.restaurantNavItems = [];
    if(user_dept=="master"){
      this.restaurantNavItems = [
        {
          displayName: 'Restaurant',
          iconName: 'star_rate',
          route: '/restaurant',
        },        
      ];
    }
   
  }


  bindSchoolNavbar()
  {  
    this.schoolNavItems = [
      {
        displayName: 'School',
        iconName: 'star_rate',
        route: '/school',
      },       
      {
        displayName: 'Instructors',
        iconName: 'person',
        route: '/school/instructors'
      }        
    ];
  }

  bindInstructorNavbar()
  {  
    this.instructorNavItems = [
      {
        displayName: 'Dashboard',
        iconName: 'star_rate',
        route: '/instructor',
      },       
      {
        displayName: 'Diary',
        iconName: 'star_rate',
        route: '/instructor/diary'
      },
      {
        displayName: 'Lessons',
        iconName: 'star_rate',
        route: '/instructor/lessons'
      },
      {
        displayName: 'Students',
        iconName: 'person',
        route: '/instructor/students'
      },
      {
        displayName: 'Add Student',
        iconName: 'person',
        route: '/instructor/add-student'
      }
    ];
  }


  
}